import { v4 as uuidv4 } from "uuid";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as ItemCardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/ItemCardBlock/ItemCardDefaultData";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

interface ImageProps {
  placeholder: string;
  signedId: string;
  styles?: Record<string, StyleValue>;
}

interface CreateItemCardBlockProps {
  description?: string;
  image?: ImageProps;
  title?: string;
}

export const createItemCardBlock = ({
  image = { signedId: "", placeholder: "" },
  title = "",
  description = "",
}: CreateItemCardBlockProps): BaseBlock => ({
  ...ItemCardDefaultData,
  id: uuidv4(),
  props: {
    ...ItemCardDefaultData.props,
    image: {
      ...ItemCardDefaultData.props.image,
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: image.signedId,
          placeholder: image.placeholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "48px",
                height: "48px",
                minWidth: "none",
                minHeight: "none",
                maxWidth: "none",
                maxHeight: "none",
              },
            }),
            ...image.styles,
          },
        }),
      ],
    },
    header: {
      ...ItemCardDefaultData.props.header,
      prop: "children",
      type: "children",
      value: [
        createH5Block({
          text: title,
        }),
      ],
    },
    description: {
      ...ItemCardDefaultData.props.description,
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: description,
          styles: {
            color: getColorOptions("var(--theme-website-color-text-muted)"),
          },
        }),
      ],
    },
  },
});
